namespace Matrix.Data {
    export interface ClientTableItem {
        DisplayName?: string;
        TableSchema?: string;
        Tablename?: string;
        FullName?: string;
    }
}
